import SocialAttendanceTypeRepository from '@/shared/http/repositories/socialProject/social-attendance-type'
import BreadCrumb from '@/components/layout/BreadCrumb/breadCrumb.vue'
import NewRegister from '@/components/layout/NewRegister/newRegister.vue'
import SocialAttendanceType from '@/shared/models/socialAttendanceType'
import { IsSuccessCode } from '@/shared/utils/API'
import { loading, toast } from '@/shared/utils/UIHelper'

export default {
  name: 'NovoTipoDeAtendimentoSocial',

  components: {
    [BreadCrumb.name]: BreadCrumb,
    [NewRegister.name]: NewRegister
  },

  data: () => ({
    placeholder: 'Nome',
    title: 'Tipo de Atendimento Social',
    socialAttendanceType: new SocialAttendanceType(),
    isNew: true
  }),

  computed: {
    breadCrumb() {
      return {
        breadcrumbItems: [
          {
            text: 'Dashboard',
            href: this.$router.resolve({ name: 'Dashboard' }).href
          },
          {
            text: 'Tipos de Atendimento Social',
            href: this.$router.resolve({ name: 'SocialAttendanceType' }).href
          },
          {
            text: 'Novo Tipo de Atendimento Social',
            active: true
          }
        ]
      }
    }
  },

  methods: {
    create(socialAttendanceType) {
      loading.push()
      SocialAttendanceTypeRepository.Create(socialAttendanceType)
        .then(res => {
          if (!IsSuccessCode(res)) return Promise.reject()

          loading.pop()
          toast.success('Tipo de Atendimento Social criado com sucesso', 'NOVO TIPO DE ATENDIMENTO SOCIAL')
          Promise.resolve()
          return this.$router.replace({ name: 'SocialAttendanceType' })
        })
        .catch(() => {
          loading.pop()
          toast.error('Erro ao criar tipo de atendimento social', 'ERRO')
        })
    }
  }
}
